import React from 'react';

/**
 * Emits a JSON-LD block into the server-rendered HTML.
 *
 * Use this rather than next/script. next/script injects the tag on the client,
 * so the markup is absent from the HTML a crawler reads. Every schema block on
 * this site was written that way and none of them were ever served.
 */
export const JsonLd = ({ data }: { data: unknown; }) => {
    if (!data) return <></>;

    // JSON.stringify handles quotes, newlines and backslashes in stored copy.
    // The one thing it does not escape is a literal </script> in a string.
    const json = JSON.stringify(data).replace(/</g, '\\u003c');

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: json }}
        />
    );
};

/**
 * Turns stored HTML into the plain sentence schema wants. Behaves identically
 * on the server and in the browser, so SSR output matches what a crawler reads.
 */
export const toPlainText = (str?: string) => (str || '')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(p|div|li|h[1-6])>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;|&rsquo;|&apos;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
